import mayor from '../images/Team/Mayor.png';
import upamayor from '../images/Team/upamayor.jpg';
import Prawakta from '../images/Team/Prawakta.jpg';
import sectiono_fficer from '../images/Team/section-officer.jpg';
import information from '../images/Team/information.jpg';



 const TeamData=[
    {
        image:mayor,
     name:"चिरीबाबु महर्जन",
     post:"नगर प्रमुख",
     email:"mayor@lmc.gov.np /",
     emailseccond:"cbmaharjan@yahoo.com",
     phone:"9851022723"
    },

    {
        image:upamayor,
        name:"गीता सत्याल",
        post:"उप– प्रमुख",
        email:"mayor@lmc.gov.np /",
        emailseccond:"gitasatyal.nepal@gmail.com",
        phone:"9851234440"
       },
       {
        image:sectiono_fficer,
        name:"गणेश अर्याल",
        post:"प्रमुख प्रशासकीय अधिकृत",
        email:"mayor@lmc.gov.np /",
        emailseccond:"ganesrishu@gmail.com",
        phone:"9851234440"
       },

       {
        image:Prawakta,
        name:"राजु महर्जन",
        post:"प्प्रवक्ता",
        email:"mayor@lmc.gov.np /",
        emailseccond:"rajumaharjan77@gmail.com",
        phone:"9851114886"
       },
       {
        image:information,
        name:"रुद्र प्रसाद गाैतम",
        post:"सूचना अधिकारी",
        email:"mayor@lmc.gov.np /",
        emailseccond:"suchanaadhikari@lalitpurmun.gov.np",
        phone:"9851062110"
       },
       {
        image:mayor,
     name:"चिरीबाबु महर्जन",
     post:"नगर प्रमुख",
     email:"mayor@lmc.gov.np /",
     emailseccond:"cbmaharjan@yahoo.com",
     phone:"9851022723"
    }

      
]

export default TeamData;